import React, { useContext } from 'react'
import { Context } from '../../../utils/context'
import "./CheckoutProducts.css"

function CheckoutProducts() {
  const {cartItems} = useContext(Context);
  
  return (
    <>
    {cartItems.map((item: any) => (
      <>
        <div className='overview-prod' key={item.id}>
            <img src={item?.attributes?.img?.data[0]?.attributes?.url} alt="" />
            <div className="overview-prod-content">
                <span style={{fontWeight:"600", paddingBottom:"10px"}}>&#8377; {item.attributes.price}</span>
                <span className='overview-prod-title'>{item.attributes.title}</span>
                <div className="qty">
                    <span>Qty: </span><span style={{fontWeight:"600"}}>{item.attributes.quantity}</span>
                </div>
            </div>
        </div>
      </>
    ))}
    </>
  )
}

export default CheckoutProducts
